import React, { useMemo } from "react";

import {
  MessageBoxConfig,
  MessageBoxWidgetDto,
  WidgetRenderType,
} from "@intelligems/ig-types";
import { MessageBoxView } from "@intelligems/ig-widgets";

interface MessageBoxWidgetStylePreviewProps {
  device: WidgetRenderType;
  widget: MessageBoxWidgetDto;
}

export const IgMessageBox = ({
  device,
  widget,
}: MessageBoxWidgetStylePreviewProps) => {
  const config = useMemo((): MessageBoxConfig => {
    return {
      id: widget.id,
      widget: widget.config,
    };
  }, [widget.id, widget.config]);
  return <MessageBoxView renderType={device} isFe={true} config={config} />;
};
